const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function trackPageView({ pathname, search, hash }) {
    if (typeof window === "undefined" || typeof window.gtag !== "function" || !MEASUREMENT_ID) return;
    window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: `${window.location.origin}${pathname}${search}${hash}`,
        send_to: MEASUREMENT_ID,
    });
}
